/**
 * True when the handler took the leads-capture path — WEBDEV-4079.
 *
 * `submissionId` comes back only on the flag-on path, so this infers the flag from the response
 * rather than reading it client-side. Used to skip syncPardotTracking: with the flag on the lead
 * already went to Salesforce, and a Pardot prospect-sync on top would double-write.
 */
export const isLeadsCaptureResponse = (response) => Boolean(response?.data?.submissionId);
